import { AppDispatch } from "context/store";
import { axiosPOSTLogin, axiosPRELogin } from "./axios";
import { errorHandler } from "./errorHandler";
import { BACKEND_ENDPOINTS } from "Theconstants";
import { PreguntaBeforeSubmission } from "pages/SingleProdPage/auxiliaries/Preguntas";

interface PaginatedResponsePreguntas {
  preguntas: IPregunta[];
  total: number;
  limit: number;
}
export const preguntasAPI = {
  getProdQuestions: async function (prodId: IProducto["_id"], page: number) {
    return axiosPOSTLogin.get<PaginatedResponsePreguntas>(
      `${BACKEND_ENDPOINTS.dynamicSingleProdPREGUNTAS(prodId)}?page=${page}`
    );
  },

  createPreg: async function (
    prodId: IProducto["_id"],
    objInfo: PreguntaBeforeSubmission,
    dispatch: AppDispatch
  ) {
    try {
      const { data } = await axiosPRELogin.post<IPregunta>(
        BACKEND_ENDPOINTS.dynamicSingleProdPREGUNTAS(prodId),
        objInfo
      );
      return data;
    } catch (error) {
      errorHandler(error, dispatch, "POST CREATE PREGUNTA");
      return Promise.reject("error custom");
    }
  },

  //POST LOGIN because I need to check admin
  deletePreg: async function (pregID: IPregunta["_id"]) {
    return axiosPOSTLogin.delete<never>(
      BACKEND_ENDPOINTS.dynamicSingleProdPREGUNTAS(pregID)
    );
  },
  //POST LOGIN because I need to check admin
  updatePreg: async function (
    pregID: IPregunta["_id"],
    replyInput: Pick<IPregunta, "reply">
  ) {
    return axiosPOSTLogin.put<IPregunta>(
      BACKEND_ENDPOINTS.dynamicSingleProdPREGUNTAS(pregID),
      replyInput
    );
  },

  getAdminAllPregs: async function (options: { page: number; filter: string }) {
    return axiosPOSTLogin.get<PaginatedResponsePreguntas>(
      BACKEND_ENDPOINTS.dynamicAdminGetAllPregs(options)
    );
  },
};
